import { Modal, useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { ChatGeneratedMediaContent } from 'api/clients/ChatClient'
import Styles from './GeneratedMediaContent.module.scss'

interface MediaPreviewModalProps {
  content: ChatGeneratedMediaContent
}

export const MediaPreviewModal = ({ content }: MediaPreviewModalProps) => {
  const { closeModal } = useModals()

  return (
    <Modal.Root onPressOutside={closeModal} blaze size="md">
      <Modal.Header title="Preview" />
      <Modal.Content>
        <div className={Styles.mediaContainer}>
          {content.type === 'generated_image' ? (
            <img src={content.image_url} alt="AI generated content" />
          ) : (
            <video src={content.video_url} poster={content.thumbnail_url} controls loop muted autoPlay />
          )}
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeModal}>
            Close
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
